<template lang="html">
  <div class="mask-container">
    <div class="upload-container">
      <div @click="close" class="close"></div>
      <div class="title">
        {{search}}
      </div>
      <div @click="clickVoice" class="uploadBtn-container">
          <img src="../assets/voice1.png">
          <img :class="isRec ? 'on' : ''" src="../assets/voice2.png">
          <img :class="isRec ? 'on' : ''" src="../assets/voice3.png">
          <img src="../assets/voice4.png">
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../bus'
import { SM4 } from 'gm-crypto';
// import audioUtils from '../../public/fronted/js/audioUtils'
// import v4 from '../../public/fronted/js/aws-signature-v4'
var audioUtils = require('../../public/fronted/js/audioUtils')
var crypto            = require('crypto'); // tot sign our pre-signed URL
// const v4                = require('../../public/fronted/js/aws-signature-v4'); // to generate our pre-signed URL
var querystring = require('query-string');
var marshaller        = require("@aws-sdk/eventstream-marshaller"); // for converting binary event stream messages to and from JSON
var util_utf8_node    = require("@aws-sdk/util-utf8-node"); // utilities for encoding and decoding UTF8
var mic               = require('microphone-stream');
var eventStreamMarshaller = new marshaller.EventStreamMarshaller(util_utf8_node.toUtf8, util_utf8_node.fromUtf8);
var socket;
var webAudioSpeechRecognizer;

export default {
  data() {
    return {
      params: {},
      sid: '',
      blob1: '',
      blob2: '',
      search: '',
      saveSearch: '',
      audio: null,
      syncid: 0,
      audioStatus: 1,
      recorder: null,
      isRec: false,
      time: null,
      language: 'zh-CN',
      blobArr: [],
      buffer: [],
      recorderWorker: null,
      AudioContext: null,
      mediaStream: null,
      context: null,
      state: '',
      stopIndex: 0,
      micStream: null,
      transcription: ''
    }
  },
    methods: {
      closeSocket() {
          if (socket.OPEN) {
              this.micStream.stop();

              // Send an empty frame so that Transcribe initiates a closure of the WebSocket after submitting all transcripts
              let emptyMessage = this.getAudioEventMessage(Buffer.from(new Buffer([])));
              let emptyBuffer = eventStreamMarshaller.marshall(emptyMessage);
              socket.send(emptyBuffer);
          }
      },
      streamAudioToWebSocket(userMediaStream) {

        var that = this;
        //let's get the mic input from the browser, via the microphone-stream module
            var micStream = new mic();
            this.micStream = micStream
            this.micStream.setStream(userMediaStream);

            // Pre-signed URLs are a way to authenticate a request (or WebSocket connection, in this case)
            // via Query Parameters. Learn more: https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-query-string-auth.html
            let url = this.createPresignedUrl();

            //open up our WebSocket connection
            socket = new WebSocket(url);
            socket.binaryType = "arraybuffer";

            // when we get audio data from the mic, send it to the WebSocket if possible
            socket.onopen = function() {
                console.log('open')
                that.micStream.on('data', function(rawAudioChunk) {
                    // the audio stream is raw audio bytes. Transcribe expects PCM with additional metadata, encoded as binary
                    let binary = that.convertAudioToBinaryMessage(rawAudioChunk);
                    // console.log(binary)
                    if (socket.OPEN){
                      console.log('send')
                      socket.send(binary);
                    }
                }
            )};

            // handle messages, errors, and close events
            this.wireSocketEvents();
    },
    wireSocketEvents() {
      var that = this;
      var transcribeException;
      // handle inbound messages from Amazon Transcribe
      socket.onmessage = function (message) {
          //convert the binary event stream message to JSON
          let messageWrapper = eventStreamMarshaller.unmarshall(Buffer(message.data));
          let messageBody = JSON.parse(String.fromCharCode.apply(String, messageWrapper.body));
          if (messageWrapper.headers[":message-type"].value === "event") {
              that.handleEventStreamMessage(messageBody);
          }else {
              console.log('noMessage')
              transcribeException = true;
              // showError(messageBody.Message);
          }
      };

      socket.onerror = function () {
          socketError = true;
          console.log('error')
      };

      socket.onclose = function (closeEvent) {
          console.log('close')
          that.micStream.stop();
      };
  },
  handleEventStreamMessage(messageJson) {
    var that = this;
    let results = messageJson.Transcript.Results;
    
    if (results.length > 0) {
        if (results[0].Alternatives.length > 0) {
            // console.log(results[0])
            let transcript = results[0].Alternatives[0].Transcript;

            // fix encoding for accented characters
            transcript = decodeURIComponent(escape(transcript));

            // transcript = that.transcription + transcript

            that.search = that.transcription + transcript;

            bus.$emit('search',{
              search: that.transcription + transcript
            })

            if (!results[0].IsPartial) {
              // console.log(123)
                that.transcription += transcript;
                // console.log(transcript)
            }
            // console.log(transcript)
        }
    }
},
  convertAudioToBinaryMessage(audioChunk) {
    // console.log(audioChunk)
      let raw = mic.toRaw(audioChunk);
      var sampleRate = 16000;
      if (raw == null)
          return;
      
      // downsample and convert the raw audio bytes to PCM
      
      let downsampledBuffer = audioUtils.downsampleBuffer(raw, sampleRate);
      
      let pcmEncodedBuffer = audioUtils.pcmEncode(downsampledBuffer);
      
      // add the right JSON headers and structure to the message
      let audioEventMessage = this.getAudioEventMessage(Buffer.from(pcmEncodedBuffer));
      
      //convert the JSON object + headers into a binary event stream message
      let binary = eventStreamMarshaller.marshall(audioEventMessage);
      
      return binary;
  },
  getAudioEventMessage(buffer){
    return {
      headers: {
        ':message-type': {
          type: 'string',
          value: 'event'
        },
        ':event-type': {
          type: 'string',
          value: 'AudioEvent'
        }
      },
      body: buffer
    }
  },
    createPresignedUrl() {
      // console.log(region,languageCode,sampleRate)
        var region = 'us-east-1';
        var languageCode = 'en-US';
        var sampleRate = '16000';
        let endpoint = "transcribestreaming." + region + ".amazonaws.com:8443";

        // get a preauthenticated URL that we can use to establish our WebSocket
        return this.createPresignedURL(
            'GET',
            endpoint,
            '/stream-transcription-websocket',
            'transcribe',
            crypto.createHash('sha256').update('', 'utf8').digest('hex'), {
                'key': '',
                'secret': '',
                'sessionToken': '',
                'protocol': 'wss',
                'expires': 15,
                'region': region,
                'query': "language-code=" + languageCode + "&media-encoding=pcm&sample-rate=" + sampleRate
            }
        );
    },
    createCanonicalRequest(method, pathname, query, headers, payload) {
      return [
        method.toUpperCase(),
        pathname,
        this.createCanonicalQueryString(query),
        this.createCanonicalHeaders(headers),
        this.createSignedHeaders(headers),
        payload
      ].join('\n');
    },
    createCanonicalQueryString(params) {
      return Object.keys(params).sort().map(function(key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
      }).join('&');
    },
    createCanonicalHeaders(headers) {
      return Object.keys(headers).sort().map(function(name) {
        return name.toLowerCase().trim() + ':' + headers[name].toString().trim() + '\n';
      }).join('');
    },
    createSignedHeaders(headers) {
      return Object.keys(headers).sort().map(function(name) {
        return name.toLowerCase().trim();
      }).join(';');
    },
    createCredentialScope(time, region, service) {
      return [this.toDate(time), region, service, 'aws4_request'].join('/');
    },
    createStringToSign(time, region, service, request) {
      return [
        'AWS4-HMAC-SHA256',
        this.toTime(time),
        this.createCredentialScope(time, region, service),
        this.hash(request, 'hex')
      ].join('\n');
    },
    createSignature(secret, time, region, service, stringToSign) {
      var h1 = this.hmac('AWS4' + secret, this.toDate(time)); // date-key
      var h2 = this.hmac(h1, region); // region-key
      var h3 = this.hmac(h2, service); // service-key
      var h4 = this.hmac(h3, 'aws4_request'); // signing-key
      return this.hmac(h4, stringToSign, 'hex');
    },
    createPresignedS3URL(name, options) {
      options = options || {};
      options.method = options.method || 'GET';
      options.bucket = options.bucket || process.env.AWS_S3_BUCKET;
      return this.createPresignedURL(
        options.method,
        options.bucket + '.s3.amazonaws.com',
        '/' + name,
        's3',
        'UNSIGNED-PAYLOAD',
        options
      );
    },
    createPresignedURL(method, host, path, service, payload, options) {
      options = options || {};
      options.key = options.key || process.env.AWS_ACCESS_KEY_ID;
      options.secret = options.secret || process.env.AWS_SECRET_ACCESS_KEY;
      options.protocol = options.protocol || 'https';
      options.headers = options.headers || {};
      options.timestamp = options.timestamp || Date.now();
      options.region = options.region || process.env.AWS_REGION || 'us-east-1';
      options.expires = options.expires || 86400; // 24 hours
      options.headers = options.headers || {};

      // host is required
      options.headers.Host = host;

      var query = options.query ? querystring.parse(options.query) : {};
      query['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
      query['X-Amz-Credential'] = options.key + '/' + this.createCredentialScope(options.timestamp, options.region, service);
      query['X-Amz-Date'] = this.toTime(options.timestamp);
      query['X-Amz-Expires'] = options.expires;
      query['X-Amz-SignedHeaders'] = this.createSignedHeaders(options.headers);
      if (options.sessionToken) {
        query['X-Amz-Security-Token'] = options.sessionToken;
      }

      var canonicalRequest = this.createCanonicalRequest(method, path, query, options.headers, payload);
      var stringToSign = this.createStringToSign(options.timestamp, options.region, service, canonicalRequest);
      var signature = this.createSignature(options.secret, options.timestamp, options.region, service, stringToSign);
      query['X-Amz-Signature'] = signature;
      return options.protocol + '://' + host + path + '?' + querystring.stringify(query);
    },
    toTime(time) {
      return new Date(time).toISOString().replace(/[:\-]|\.\d{3}/g, '');
    },
    toDate(time) {
      return this.toTime(time).substring(0, 8);
    },
    hmac(key, string, encoding) {
      return crypto.createHmac('sha256', key)
        .update(string, 'utf8')
        .digest(encoding);
    },
    hash(string, encoding) {
      return crypto.createHash('sha256')
        .update(string, 'utf8')
        .digest(encoding);
    },
    close() { // 关闭语音识别弹框
      bus.$emit('closeVoiceUpload');
      if(this.isRec){
        webAudioSpeechRecognizer.stop();
        this.isRec = false;
      }
      this.search = '';
      // if(this.language=='zh-CN'){
      //   this.stop();
      // }else{
      //   if (socket.OPEN) {
      //       this.micStream.stop();

      //       // Send an empty frame so that Transcribe initiates a closure of the WebSocket after submitting all transcripts
      //       let emptyMessage = this.getAudioEventMessage(Buffer.from(new Buffer([])));
      //       let emptyBuffer = eventStreamMarshaller.marshall(emptyMessage);
      //       socket.send(emptyBuffer);
      //   }else{
      //     this.micStream.stop();
      //   }
      // }
    },
    IsPC() { // 判断是否是PC端
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                  "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
      return flag;
    },
    startRec () { // 麦克风录音开始
      var that = this;
      clearInterval(that.handlerInterval);
      that.mediaStream.connect(this.recorder)
      that.recorder.connect(this.context.destination)
      setTimeout(() => {
        var audioData = that.buffer.splice(0, 3840);
        var data1 = {
            "jsonrpc": "2.0",
            "method": "deal_request",
            "params": {
                "svc": "iat",
                "cmd": "auw",
                "type": "1",
                "appid": "5da43f9b",
                "sid": that.sid,
                "uid": "test",
                "data": that.ArrayBufferToBase64(audioData),
                "audioStatus": 1,
                "syncid": that.syncid
            },
            "id": 2
        }
        that.syncid = that.syncid + 1;
        var obj = JSON.stringify(data1);
        $.ajax({
            url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
            type: 'POST',
            data: {
                data: obj
            },
            success: function(res) {
                // console.log(res);
                if(res!=''&&res!=null&&res!=undefined){
                    var StrBase64 = new Buffer(res, 'base64')
                    var Str = StrBase64.toString();
                    Str = JSON.parse(Str)
                    // console.log(Str)
                    // that.syncid++;
                    // that.sendAudio2(that.blob2);
                }
            }
        })
        that.handlerInterval = setInterval(() => {
          // if (that.buffer.length === 0) {
          //   if (this.state === 'end') {
          //     clearInterval(this.handlerInterval)
          //   }
          //   return false
          // }
          // console.log(audioData)
          if(that.isRec){
            if(that.syncid%18==0){
              // consoel.log()
              clearInterval(this.handlerInterval)
              var data1 = {
                "jsonrpc": "2.0",
                "method": "deal_request",
                "params": {
                    "svc": "iat",
                    "cmd": "auw",
                    "type": "1",
                    "appid": "5da43f9b",
                    "sid": that.sid,
                    "uid": "test",
                    "data": '',
                    "audioStatus": 4,
                    "syncid": that.syncid
                },
                "id": 2
              }
              that.syncid = that.syncid + 1;
              var obj = JSON.stringify(data1);
              $.ajax({
                  url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
                  type: 'POST',
                  data: {
                      data: obj
                  },
                  success: function(res) {
                      // console.log(res);
                      if(res!=''&&res!=null&&res!=undefined){
                          var StrBase64 = new Buffer(res, 'base64')
                          var Str = StrBase64.toString();
                          Str = JSON.parse(Str)
                          // console.log(1233123,Str)
                          // that.syncid++;
                          // that.sendAudio2(that.blob2);
                          that.sendAudio3();
                      }
                  }
              })
            }else{
              audioData = that.buffer.splice(0, 3840)
              // 中间帧
              var data1 = {
                "jsonrpc": "2.0",
                "method": "deal_request",
                "params": {
                    "svc": "iat",
                    "cmd": "auw",
                    "type": "1",
                    "appid": "5da43f9b",
                    "sid": that.sid,
                    "uid": "test",
                    "data": that.ArrayBufferToBase64(audioData),
                    "audioStatus": 2,
                    "syncid": that.syncid
                },
                "id": 2
              }
              that.syncid = that.syncid + 1;
              var obj = JSON.stringify(data1);
              $.ajax({
                  url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
                  type: 'POST',
                  data: {
                      data: obj
                  },
                  success: function(res) {
                      // console.log(res);
                      if(res!=''&&res!=null&&res!=undefined){
                          var StrBase64 = new Buffer(res, 'base64')
                          var Str = StrBase64.toString();
                          Str = JSON.parse(Str)
                          // console.log(Str)
                          // that.syncid++;
                          // that.sendAudio2(that.blob2);
                      }
                  }
              })
            }
          }
        }, 100)
      }, 500)
    },

    start () { // 打开麦克风录音
      var that = this;
      this.buffer = [];
      // this.stop()
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.mediaDevices.getUserMedia
      if (navigator.getUserMedia && that.AudioContext) {
        this.state = 'ing'

        // if (!this.recorder) {
          var context = new this.AudioContext()
          this.context = context
          this.recorder = context.createScriptProcessor(0, 1, 1)
          var getMediaSuccess = (stream) => {
            that.audio = stream;
            var mediaStream = that.context.createMediaStreamSource(stream)
            that.mediaStream = mediaStream
            // console.log(123)
            that.recorder.onaudioprocess = (e) => {
              // console.log(e.inputBuffer.getChannelData(0))
              that.sendData(e.inputBuffer.getChannelData(0))
            }
            // this.connectWebsocket()
            that.startRec();
          }
          var getMediaFail = (e) => {
            this.recorder = null
            this.mediaStream = null
            this.context = null
            // console.log('请求麦克风失败')
            if(this.language==='zh-CN'){
              this.$message({
                type: 'warning',
                message: '未识别到设备'
              })
            }else{
              this.$message({
                type: 'warning',
                message: 'Device not recognized'
              })
            }
          }
          if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({
              audio: true,
              video: false
            }).then((stream) => {
              getMediaSuccess(stream)
            }).catch((e) => {
              getMediaFail(e)
            })
          } else {
            navigator.getUserMedia({
              audio: true,
              video: false
            }, (stream) => {
              getMediaSuccess(stream)
            }, function (e) {
              getMediaFail(e)
            })
          }
        // }
      }
    },

    stop () { // 关闭麦克风录音
      var that = this;
      if(that.recorder!=null&&that.recorder!=undefined&&that.recorder!=''){
        that.recorder.disconnect();
      }
      that.buffer = [];
      if(that.handlerInterval!=null&&that.handlerInterval!=undefined&&that.handlerInterval!=''){
        clearInterval(that.handlerInterval)
      }
      clearInterval(that.handlerInterval)
      that.isRec = false;
      bus.$emit('closeVoiceUpload');
    },

    sendData (buffer) {
      this.recorderWorker.postMessage({
        command: 'transform',
        buffer: buffer
      })
    },

    initRecording() { // 初始化录音事件
        var that = this;
        // 音频转码worker
        let recorderWorker = new Worker('./fronted/js/transformpcm.worker.js')
        // console.log(recorderWorker)
        // 记录处理的缓存音频
        let buffer = []
        let AudioContext = window.AudioContext || window.webkitAudioContext
        that.recorderWorker = recorderWorker;
        that.buffer = buffer;
        that.AudioContext = AudioContext;
        recorderWorker.onmessage = function (e) {
          buffer.push(...e.data.buffer)
          that.buffer = buffer;
        }
    },

    ArrayBufferToBase64 (buffer) { // ArrayBuffer转Base64
      var binary = ''
      var bytes = new Uint8Array(buffer)
      var len = bytes.byteLength
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },

    getSid() { // 获取语音识别SID
        var that = this;
        this.syncid = 0;
        var data1 = {
            "id" : 1,
            "jsonrpc" : "2.0",
            "method" : "deal_request",
            "params" : {
                "appid" : "5da43f9b",
                "aue" : "raw",
                "auf" : "audio/L16;rate=16000",
                "auth_id" : "",
                "auth_need" : "false",
                "cmd" : "ssb",
                "private_key" : "",
                "svc" : "iat",
                "syncid" : this.syncid,
                "type" : "1",
                "uid" : "660Y5r"
            }
        }
        this.syncid++;
        var obj = JSON.stringify(data1);
        $.ajax({
            url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
            type: 'POST',
            dataType: 'json',
            data: {
                data: obj
            },
            success: function(res) {
                if(res!=''&&res!=null&&res!=undefined){
                    res = JSON.parse(atob(res));
                    // console.log(res)
                    that.sid = res.result.sid;
                    that.syncid++;
                }
            }
        })
    },
    startRecording() { // 开始录音
      var that = this;
      // this.blob1 = '',
      // this.blob2 = '',
      // this.recorder.start();
      // this.getSid();
      if(that.handlerInterval!=null&&that.handlerInterval!=undefined&&that.handlerInterval!=''){
        clearInterval(that.handlerInterval)
      }
      this.getSid();
      this.start();
    },
    stopRecording() { // 暂停录音
        var that = this;
        this.stop();
    },
    sendAudio(data) {
        var that = this;
        var audioStatus = 1;
        if(that.syncid>1){
            audioStatus = 2
        }else{
            audioStatus = 1
        }
        var data1 = {
            "jsonrpc": "2.0",
            "method": "deal_request",
            "params": {
                "svc": "iat",
                "cmd": "auw",
                "type": "1",
                "appid": "5da43f9b",
                "sid": this.sid,
                "uid": "test",
                "data": data,
                "audioStatus": audioStatus,
                "syncid": this.syncid
            },
            "id": 2
        }
        var obj = JSON.stringify(data1);
        $.ajax({
            url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
            type: 'POST',
            data: {
                data: obj
            },
            success: function(res) {
                // console.log(res);
                if(res!=''&&res!=null&&res!=undefined){
                    var StrBase64 = new Buffer(res, 'base64')
                    var Str = StrBase64.toString();
                    Str = JSON.parse(Str)
                    // console.log(Str)
                    that.syncid++;
                    that.sendAudio2(that.blob2);
                }
            }
        })
    },
    sendAudio2(data) {
        var that = this;
        var audioStatus = 4;
        var data1 = {
            "jsonrpc": "2.0",
            "method": "deal_request",
            "params": {
                "svc": "iat",
                "cmd": "auw",
                "type": "1",
                "appid": "5da43f9b",
                "sid": this.sid,
                "uid": "test",
                "data": data,
                "audioStatus": audioStatus,
                "syncid": this.syncid
            },
            "id": 2
        }
        var obj = JSON.stringify(data1);
        // console.log(obj)
        $.ajax({
            url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
            type: 'POST',
            data: {
                data: obj
            },
            success: function(res) {
                // console.log(res);
                if(res!=''&&res!=null&&res!=undefined){
                    var StrBase64 = new Buffer(res, 'base64')
                    var Str = StrBase64.toString();
                    Str = JSON.parse(Str)
                    // console.log(Str)
                    that.syncid++;
                    that.sendAudio3()
                }
            }
        })
    },
    sendAudio3(synid) {
        // var length1 = Number(synid) + 1;
        // console.log(length1)
        var that = this;
        var audioStatus = 4;
        var data1 = {
            "jsonrpc": "2.0",
            "method": "deal_request",
            "params": {
                "svc": "iat",
                "cmd": "grs",
                "appid": "5da43f9b",
                "sid": this.sid,
                "uid": "test",
                // "syncid": length1,
                "syncid": this.syncid
            },
            "id": 3
        }
        var obj = JSON.stringify(data1);
        // console.log(obj)
        $.ajax({
            url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
            type: 'POST',
            data: {
                data: obj
            },
            success: function(res) {
                // console.log(res);
                that.stopIndex = that.stopIndex + 1;
                that.clearSid();
                if(res!=''&&res!=null&&res!=undefined){
                    var StrBase64 = new Buffer(res, 'base64')
                    var Str = StrBase64.toString();
                    Str = JSON.parse(Str)
                    // console.log(123123123,Str)
                    if(Str.result!=''&&Str.result!=undefined&&Str.result!=null){
                      if(Str.result.rec_result==''||Str.result.rec_result==undefined||Str.result.rec_result==null){
                        // if(that.language==='zh-CN'){
                        //   that.$message({
                        //     type: 'warning',
                        //     message: '未识别到语音'
                        //   })
                        // }else{
                        //   that.$message({
                        //     type: 'warning',
                        //     message: 'Unrecognized speech'
                        //   })
                        // }

                      }else{
                        if(that.isRec){
                          that.stopIndex = 0;
                          var search = that.search;
                          search += Str.result.rec_result;
                          // var search = Str.result.rec_result;
                          // that.search =  that.saveSearch + search;
                          that.search = search;
                          bus.$emit('search',{
                            search: search
                          })
                        }
                      }
                    }else{

                    }
                    that.syncid = 0;
                }
            }
        })
        // that.getSid();
        // that.startRec();
    },
    clearSid() { // 语音识别结束清除SID
      var that = this;
      var data1 = {
          "jsonrpc": "2.0",
          "method": "deal_request",
          "params": {
              "cmd": "sse",
              "svc": "iat",
              "appid": "5da43f9b",
              "sid": this.sid,
              "uid": "test"
          },
          "id": 4
      }
      // if(Number(that.stopIndex)>=3){
      //   var that = this;
      //   if(that.recorder!=null&&that.recorder!=undefined&&that.recorder!=''){
      //     that.recorder.disconnect();
      //   }
      //   that.buffer = [];
      //   if(that.handlerInterval!=null&&that.handlerInterval!=undefined&&that.handlerInterval!=''){
      //     clearInterval(that.handlerInterval);
      //   }
      //   that.isRec = false;
      //   bus.$emit('closeVoiceUpload');
      // }
      var obj = JSON.stringify(data1);
      $.ajax({
          url: require('../config.json').urlBase + require('../config.json').url.curl.curl,
          type: 'POST',
          data: {
              data: obj
          },
          success: function(res) {
              // if(res!=''&&res!=null&&res!=undefined){
                // if(Number(that.stopIndex)<3){
                  that.getSid();
                  that.startRec();
                // }

                // if(Number(that.stopIndex)>=3){
                //   var that = this;
                //   that.recorder.disconnect();
                //   that.buffer = [];
                //   clearInterval(that.handlerInterval)
                // }
              // }
          }
      })
    },
    clickVoice() { // 播放器按钮动画效果事件
      var that = this;
      if(!this.isRec){
        let resultText = '';
        if(that.language==='zh-CN'){
          this.params.engine_model_type = '16k_zh'
        }else{
          this.params.engine_model_type = '16k_en'
        }
        console.log(this.params)
        webAudioSpeechRecognizer = new WebAudioSpeechRecognizer(this.params);
        // 开始识别
        webAudioSpeechRecognizer.OnRecognitionStart = (res) => {
          console.log('开始识别', res);
        };
        // 一句话开始
        webAudioSpeechRecognizer.OnSentenceBegin = (res) => {
          console.log('一句话开始', res);
          this.isRec = true;
        };
        // 识别变化时
        webAudioSpeechRecognizer.OnRecognitionResultChange = (res) => {
          console.log('识别变化时', res);
          const currentText = `${resultText}${res.result.voice_text_str}`;
          this.search = currentText
          bus.$emit('search',{
            search: currentText
          })
          // areaDom.text(currentText);
        };
        // 一句话结束
        webAudioSpeechRecognizer.OnSentenceEnd = (res) => {
          console.log('一句话结束', res);
          resultText += res.result.voice_text_str;
          this.search = resultText
          bus.$emit('search',{
            search: resultText
          })
          // areaDom.text(resultText);
        };
        // 识别结束
        webAudioSpeechRecognizer.OnRecognitionComplete = (res) => {
          console.log('识别结束', res);
        };
        // 识别错误
        webAudioSpeechRecognizer.OnError = (res) => {
          console.log('识别失败', res)
          this.isRec = false;
          if(that.language==='zh-CN'){
            this.$message({
              type: 'warning',
              message: '未识别到设备'
            })
          }else{
            that.$message({
              type: 'warning',
              message: 'Device not recognized'
            })
          }
        };
        webAudioSpeechRecognizer.start();
      }else{
        this.isRec = false;
        webAudioSpeechRecognizer.stop();
      }
      
      // function ac(stream) {
      //   that.streamAudioToWebSocket(stream)
      // }
      // if(this.language=='zh-CN'){
      //   this.stopIndex = 0;
      //   if(this.isRec===false){
      //     this.isRec = true;
      //     this.startRecording();
      //   }else{
      //     this.isRec = false;
      //     this.stopRecording();
      //     bus.$emit('closeVoiceUpload');
      //   }
      // }else{
      //   if(this.isRec===false){
      //     this.isRec = true;
      //     navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.mediaDevices.getUserMedia
      //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      //       navigator.mediaDevices.getUserMedia({
      //         audio: true,
      //         video: false
      //       }).then((stream) => {
      //         that.streamAudioToWebSocket(stream)
      //       }).catch((e) => {
      //         if(that.language==='zh-CN'){
      //           this.$message({
      //             type: 'warning',
      //             message: '未识别到设备'
      //           })
      //         }else{
      //           that.$message({
      //             type: 'warning',
      //             message: 'Device not recognized1'
      //           })
      //         }
      //       })
      //     } else {
      //       navigator.getUserMedia({
      //         audio: true,
      //         video: false
      //       }, (stream) => {
      //         that.streamAudioToWebSocket(stream)
      //       }, function (e) {
      //         if(that.language==='zh-CN'){
      //           this.$message({
      //             type: 'warning',
      //             message: '未识别到设备'
      //           })
      //         }else{
      //           that.$message({
      //             type: 'warning',
      //             message: 'Device not recognized1'
      //           })
      //         }
      //       })
      //     }
      //   }else{
      //     this.isRec = false;
      //     this.closeSocket();
      //     bus.$emit('closeVoiceUpload');
      //   }
      // }
    },
    getDhInfo() {
      var that = this;
      require('../utils.js').requestWithToken({
        url: require('../config.json').urlBase + require('../config.json').url.info.getdhinfo,
        success: function(res) {
          if(res.code==='10000'){
            // console.log(res)
            const b = Math.floor(Math.random() * 10);
            const bigKey = bigInt(res.result.g).modPow(bigInt(b), bigInt(res.result.p)).toString();
            const str1 = bigKey.slice(0, 4);
            const str2 = bigKey.slice(-4);
            const str3 = bigKey.substring(Math.floor(bigKey.length / 2), Math.floor(bigKey.length / 2) + 8);
            const key = str1 + str2 + str3;

            const bigKey1 = bigInt(res.result.server_number).modPow(bigInt(b), bigInt(res.result.p)).toString();
            const str11 = bigKey1.slice(0, 4);
            const str21 = bigKey1.slice(-4);
            const str31 = bigKey1.substring(Math.floor(bigKey1.length / 2), Math.floor(bigKey1.length / 2) + 8);
            const key1 = str11 + str21 + str31;
            // console.log(key1)
            require('../utils.js').requestWithToken({
              url: require('../config.json').urlBase + require('../config.json').url.info.getrecinfo,
              data: {
                client_number: bigKey,
                unique: res.result.unique,
                key1: key1
              },
              success: function(res) {
                if(res.code==='10000'){

                  // console.log(res,key1)
                  var SecretId = SM4.decrypt(res.result.SecretId, String(that.stringToHex(key1)), {
                    inputEncoding: 'base64',
                    outputEncoding: 'utf8'
                  })

                  var AppId = SM4.decrypt(res.result.AppId, String(that.stringToHex(key1)), {
                    inputEncoding: 'base64',
                    outputEncoding: 'utf8'
                  })

                  var SecretKey = SM4.decrypt(res.result.SecretKey, String(that.stringToHex(key1)), {
                    inputEncoding: 'base64',
                    outputEncoding: 'utf8'
                  })

                  let config = {
                    secretKey: SecretKey,
                    secretId: SecretId,
                    appId: AppId,
                  }

                  window.config = config

                  that.params = {
                    signCallback: signCallback, // 鉴权函数
                    // 用户参数
                    secretid:  config.secretId,
                    appid: config.appId,
                    // 实时识别接口参数
                    engine_model_type : '16k_zh', // 因为内置WebRecorder采样16k的数据，所以参数 engineModelType 需要选择16k的引擎，为 '16k_zh'
                    // 以下为非必填参数，可跟据业务自行修改
                    voice_format : 1,
                    hotword_id : '08003a00000000000000000000000000',
                    needvad: 1,
                    filter_dirty: 1,
                    filter_modal: 2,
                    filter_punc: 0,
                    convert_num_mode : 1,
                    word_info: 2
                  }

                  // console.log(this.params)

                  // console.log(SecretId,AppId,SecretKey)
                  
                }else{
                  if(that.language==='zh-CN'){
                    that.$message({
                      type: 'warning',
                      message: res.error.message.zh_msg
                    })
                  }else{
                    that.$message({
                      type: 'warning',
                      message: res.error.message.en_msg
                    })
                  }
                }
              },
              error: function() {
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'error',
                        message: '网络错误'
                    })
                }else{
                    that.$message({
                        type: 'error',
                        message: 'Network Error'
                    })
                }
              }
            })
          }else{
            if(that.language==='zh-CN'){
              that.$message({
                type: 'warning',
                message: res.error.message.zh_msg
              })
            }else{
              that.$message({
                type: 'warning',
                message: res.error.message.en_msg
              })
            }
          }
        },
        error: function() {
          if(that.language==='zh-CN'){
              that.$message({
                  type: 'error',
                  message: '网络错误'
              })
          }else{
              that.$message({
                  type: 'error',
                  message: 'Network Error'
              })
          }
        }
      })
    },
    Decrypt(word, key){ SM4.decrypt(this.stringToBase64(word), String(this.stringToHex(key)), {
      inputEncoding: 'base64',
      outputEncoding: 'utf8',
    })},
    stringToBase64(sha1) {
      const digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      let base64_rep = '';
      let bit_arr = 0;
      let bit_num = 0;
      let ascv;
      for (
        let n = 0; n < sha1.length; ++n) {
        if (sha1[n] >= 'A' && sha1[n] <= 'Z') {
          ascv = sha1.charCodeAt(n) - 55;
        } else if (sha1[n] >= 'a' && sha1[n] <= 'z') {
          ascv = sha1.charCodeAt(n) - 87;
        } else {
          ascv = sha1.charCodeAt(n) - 48;
        }
        bit_arr = (bit_arr << 4) | ascv;
        bit_num += 4;
        if (bit_num >= 6) {
          bit_num -= 6;
          base64_rep += digits[bit_arr >>> bit_num];
          bit_arr &= ~(-1 << bit_num);
        }
      }
      if (bit_num > 0) {
        bit_arr <<= 6 - bit_num;
        base64_rep += digits[bit_arr];
      }
      const padding = base64_rep.length % 4;
      if (padding > 0) {
        for (
          let n = 0; n < 4 - padding; ++n) {
          base64_rep += '=';
        }
      }
      return base64_rep;
    },
    Encrypt(word, key) {
      const encryptedData = SM4.encrypt(String(word), String(this.stringToHex(key)), {
        inputEncoding: 'utf8',
        outputEncoding: 'hex',
      });
      return encryptedData;
    },
    stringToHex(str) {
      let val = '';
      for (let i = 0; i < str.length; i++) {
        if (val === '') {
          val = str.charCodeAt(i).toString(16); // 获取字符的Unicode码然后转16进制
        } else {
          val += str.charCodeAt(i).toString(16);// 获取字符的Unicode码然后转16进制再拼接
        }
      }
      return val;
    }
  },
  mounted() {
    var isPc = this.IsPC();
    this.initRecording();
    var audioUtils        = require('../../public/fronted/js/audioUtils');  // for encoding audio data as PCM
    this.getDhInfo()
    // this.streamAudioToWebSocket();
    // if(isPc){
    //   this.initRecording();
    // }else{

    // }
  },
  created() {
    this.language = this.$i18n.locale;
  }
}
</script>

<style scoped>
  .title {
      font-size: 0.4rem;
      color: #10163e;
  }

  .mask-container {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: rgba(16,22,62,0.2);
  }

  .upload-container {
    position: fixed;
    bottom: 0px;
    left: 50%;
    margin-left: -9.4rem;
    width: 18.8rem;
    height: 5.12rem;
    border-radius: 6px 6px 0 0;
    background: #FFF;
    border: 0.04rem solid #e0e7ff;
    padding: 0.48rem 0.4rem;
    box-sizing: border-box;
    cursor: pointer;
  }

  .upload-container .close {
    position: absolute;
    top: 0.22rem;
    right: 0.17rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url('../assets/close.png') no-repeat;
    background-position: center;
    background-size: 100%;
    cursor: pointer;
  }

  .upload-container .close:hover {
    position: absolute;
    top: 0.22rem;
    right: 0.17rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url('../assets/closeOn.png') no-repeat;
    background-position: center;
    background-size: 100%;
  }

  .upload-container .uploadBtn {
    position: relative;
    width: 2.6rem;
    height: 2.6rem;
    margin: 1.24rem 0 0.3rem 0;
  }

  .upload-container img:nth-of-type(1) {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -0.9rem;
    margin-left: -0.9rem;
    width: 1.8rem;
    height: 1.8rem;
    z-index: 1;
  }

  .upload-container img:nth-of-type(2) {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -1.55rem;
    margin-left: -1.55rem;
    width: 3.1rem;
    height: 3.1rem;
    z-index: 1;
    opacity: 0;
  }

  .upload-container img:nth-of-type(2).on {
    animation: show 1s infinite;
  }

  .upload-container img:nth-of-type(3) {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -0.98rem;
    margin-left: -0.985rem;
    width: 1.97rem;
    height: 1.96rem;
    opacity: 0;
  }

  .upload-container img:nth-of-type(3).on {
    animation: show 1s infinite;
  }

  .upload-container img:nth-of-type(4) {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -0.51rem;
    margin-left: -0.33rem;
    width: 0.66rem;
    height: 1.02rem;
    z-index: 2;
  }

  @keyframes show {
    0% {
      opacity: 1
    }
    50%{
      opacity: 0
    }
    100%{
      opacity: 1
    }
  }

  .uploadBtn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 3.1rem;
    height: 3.1rem;
  }

  .faceBtn {
    width: 1.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.28rem;
    color: #1e69fe;
    border: 0.02rem solid #5e8df7;
    border-radius: 40px;
    box-sizing: border-box;
    user-select: none;
    cursor: pointer;
  }
</style>
